import React from 'react';
import { 
  LayoutDashboard, 
  Stethoscope, 
  TestTube, 
  ShieldCheck,
  HeartPulse,
  LogOut
} from 'lucide-react';

interface SidebarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  setIsMobileMenuOpen: (open: boolean) => void;
  user: string | null;
  handleLogout: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ 
  activeTab, 
  setActiveTab, 
  setIsMobileMenuOpen, 
  user, 
  handleLogout 
}) => {
  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { id: 'live-consult', label: 'Live Consult', icon: Stethoscope },
    { id: 'lab-analysis', label: 'Lab Analysis', icon: TestTube },
    { id: 'audit-logs', label: 'AI Audit Logs', icon: ShieldCheck },
  ];

  return (
    <div className="flex flex-col h-full">
      {/* Logo */}
      <div className="p-6 flex items-center gap-3">
        <div className="bg-raspberry-600 p-2 rounded-lg text-white">
          <HeartPulse size={24} />
        </div>
        <div>
          <h1 className="font-bold text-slate-900 leading-tight">Cardio-Onc</h1>
          <p className="text-xs text-raspberry-600 font-bold tracking-wide">AI ASSISTANT</p>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-4 space-y-1 mt-4">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => {
                setActiveTab(item.id);
                setIsMobileMenuOpen(false);
              }}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg font-medium transition-colors ${
                isActive 
                  ? 'bg-raspberry-50 text-raspberry-700' 
                  : 'text-slate-500 hover:bg-slate-50 hover:text-slate-900'
              }`}
            >
              <Icon size={20} />
              {item.label}
            </button>
          );
        })}
      </nav>

      {/* Status */}
      <div className="p-6 border-t border-slate-100 space-y-4">
        <div>
          <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-2">Status</p>
          <div className="flex items-center gap-2 text-sm font-medium text-slate-700">
            <div className="w-2 h-2 rounded-full bg-emerald-500"></div>
            Governance Active
          </div>
        </div>
        
        <div className="pt-2">
          <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-2">User Session</p>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 text-sm font-bold text-slate-900 truncate max-w-[120px]">
              {user}
            </div>
            <button 
              onClick={handleLogout}
              className="p-1.5 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-md transition-colors"
              title="Logout"
            >
              <LogOut size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
